<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel" i18n="@@" >Request Signature <span *ngIf="clientName"> - {{clientName}}</span> </h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        id="close-modal" (click)="close()"></button>
</div>
<div class="card-body p-3">

    <div class="col-lg-12 mb-3">
        <label i18n="@@">Email</label>
        <input  class="form-control" type="text" required [pattern]="emailPattern" #email="ngModel" [ngClass]="{ 'is-invalid': (email.invalid && ((email.dirty || email.touched) || submitted == true))}"  placeholder="Enter Email" i18n-placeholder="@@" [(ngModel)]="model.email" (keypress) = "modalEdited = true" />
        <div *ngIf="(email.invalid && ((email.dirty || email.touched) || submitted == true))" 
        class='invalidInputTextMessage' > 
            <div *ngIf="email.errors?.['required'] else elseEmail">
                <div i18n = "@@">Email is Required</div>
            </div>
            <ng-template #elseEmail>
            <div *ngIf="email.invalid">
                <div i18n = "@@">Email Invalid</div>
            </div>
            </ng-template>
        </div> 
    </div>
    
    <div class="hstack d-flex justify-content-end">
        <button [disabled] = submitted type="button" class="btn btn-success " id="add-btn" (click)="sendEmail()" i18n="@@">Send Email Request</button>
    </div>

</div>
